// The workflow's "ask for more help" line ("Simply reply below to ask another
// question.") is the answer step's text, posted again after every Kai turn. It
// says nothing new right after a capture or Verify email card (the card IS the
// next step), a capture the customer just sent, or another copy of itself — so
// it isn't shown there. Display only: the comments stay as they are.

import { isCaptureLogsNotice } from "./CaptureRequest";

type CommentLike = { type?: string; data?: any };

const isAskForMoreHelpStep = (comment?: CommentLike | null): boolean =>
  comment?.type === "BOT" && comment?.data?.action?.type === "answerbotflow";

const isShown = (comment?: CommentLike | null): boolean =>
  !!comment &&
  !isCaptureLogsNotice(comment) &&
  comment.data?.hiddenAction !== true;

/** Whether the answer-step line at `index` would only repeat what's right above it. */
export const isRedundantAskForMoreHelp = (
  comments: CommentLike[] | null | undefined,
  index: number,
): boolean => {
  if (!comments || index <= 0) {
    return false;
  }
  for (let i = index - 1; i >= 0; i--) {
    const previous = comments[i];
    if (!isShown(previous)) {
      continue;
    }
    return (
      !!previous.data?.captureRequest ||
      !!previous.data?.capture ||
      previous.data?.action?.type === "verifyemail" ||
      isAskForMoreHelpStep(previous)
    );
  }
  return false;
};

/** The same rule for the awaiting step (the tail BotActionInput renders). */
export const isRedundantTailAskForMoreHelp = (
  comments: CommentLike[] | null | undefined,
): boolean => {
  const list = comments ?? [];
  let tail = list.length - 1;
  while (tail >= 0 && isCaptureLogsNotice(list[tail])) {
    tail--;
  }
  // The awaiting step itself (hidden or not) is the tail; judge what is above it.
  const index = isAskForMoreHelpStep(list[tail]) ? tail : list.length;
  return isRedundantAskForMoreHelp(list, index);
};
